module.exports = __webpack_public_path__ + "img/icons8-berry-jam-96.d6719b03.png";